import SalaryCard from "./SalaryCard";
import EarnerCard from "./EarnerCard";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import useTranslator from "../../hooks/useTranslator";
import CloseIcon from "../../assets/img/closeIcon.svg";
const TotalSalaryModal = ({
  isOpen,
  onClose,
  handleUpdateSource,
  effortObj,
  userIncome,
  user,
  gurantorsIncome = [],
  setUpdateSourceObj,
  showReportIcons = true,
}) => {
  const { _t } = useTranslator();
  if (!isOpen) return;

  return (
    <div className="wrapper-modal" onClick={onClose}>
      <div
        className={`doc-history-popup total-salary-modal ${
          isOpen ? "open" : ""
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="doc-history-header">
          <img
            src={CloseIcon}
            alt=""
            className="doc-history-close-btn"
            onClick={onClose}
          />
          <h4 className="custom-modal-heading">{_t("totalSalary")}</h4>
        </div>
        <SalaryCard effortObj={effortObj} />
        <div className="total-earners-wrapper">
          <h4>{_t("totalEarners")}</h4>
          <span className="earner-count">
            {(user?.gurantor_id?.length ?? 0) + 1}
          </span>
        </div>
        <div className="earner-card-wrapper">
          {
            <EarnerCard
              handleUpdateSource={handleUpdateSource}
              userData={userIncome}
              type="tenant"
              setUpdateSourceObj={setUpdateSourceObj}
              allowViewProfile={false}
              showReportIcons={showReportIcons}
              user={user}
            />
          }
          {gurantorsIncome.map((data) => (
            <EarnerCard
              handleUpdateSource={handleUpdateSource}
              userData={data}
              type="guarantor"
              setUpdateSourceObj={setUpdateSourceObj}
              onClose={onClose}
              showReportIcons={showReportIcons}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TotalSalaryModal;
